import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { Section } from './Section';
import { TrustpilotStars } from './TrustpilotStars';
import { GoogleStars } from './GoogleStars';
import { Typography } from './Typography';

interface ReviewCarouselProps {
  items: ReviewProps[];
  heading: string;
}

interface ReviewProps {
  type: 'google' | 'trustpilot';
  text: string;
  rating: number;
  url?: string;
  date: string;
}

const StyledReview = styled.a`
  ${({ theme: { global, colors, space } }) => css`
    // Reset text underline from the entire review being a link
    text-decoration: none;

    display: flex;
    flex-direction: column;
    gap: ${space.lg};

    // Expand out of the carousel wrapper div slightly for nicer/larger hover & focus-visible area
    border-radius: ${global.borderRadius.default};
    margin: -${space.sm};
    padding: ${space.sm};

    // If we want to introduce a brand new style... this would be nice to indicate interactive-area
    &:hover {
      background: ${colors.grey1.default};
    }

    blockquote {
      height: 4lh;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
    }
  `};
`;

export const ReviewCarousel: FC<ReviewCarouselProps> = ({ items, heading }) => {
  if (items.length < 1) {
    return null;
  }

  return (
    <Section contained background="white" overflowHidden>
      <CardCarouselWrapper heading={heading} width="wide" hideNavigation={false} disableOffset>
        {items.map(({ url, type, rating, text, date }, index) => (
          <div key={index}>
            <StyledReview href={url} target="_blank">
              {type === 'google' ? <GoogleStars rating={rating} /> : <TrustpilotStars rating={rating} />}
              <blockquote>{text}</blockquote>
              <Typography variant="bodySmall" component="time">
                {date}
              </Typography>
            </StyledReview>
          </div>
        ))}
      </CardCarouselWrapper>
    </Section>
  );
};
